import React, { useState, useEffect } from "react";
import { ApplicationRoles } from "../../Apis/Organization-User";
import {
  Box,
  Button,
  Stepper,
  Step,
  StepLabel,
  Typography,
  TextField,
  Paper,
  CircularProgress,
  Grid,
  Alert,
  MenuItem,
} from "@mui/material";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { fetchUserTypes } from "../../Apis/UserTypes";
import Header from "../DataLayouts/Header";
import useAuthStore from "../../Zustand/Store/useAuthStore";
import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";
import { fetchGeneralCountries } from "../../Apis/OrganizationLocation";
import SelectWithImage from "../../Components/Inputs/SelectWithImage";

function UsersEdit({ mode = "edit" }) {
  const isViewMode = mode === "view";
  const [btnLoading, setBtnLoading] = useState(false);
  const [Roles, setRoles] = useState([]);
  const { userData } = useAuthStore();
  const [userTypes, setUserTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [countryCode, setCountryCode] = useState(null);
  const [loading, setLoading] = useState();
  const [formErrors, setFormErrors] = useState({});
  const [otherApplicationRoles, setOtherApplicationRoles] = useState([]);
  const [userDetails, setUserDetails] = useState({
    full_name: "",
    phone_number: "",
    email: "",
    organization_user_type_id: "",
    phone_code: "",
    organization_user_role_id: "",
    application_user_role_id: "",
  });

  const org = userData?.organization;
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!org?.organization_id) {
      return;
    }
    ApplicationRoles(org.organization_id)
      .then((data) => {
        setRoles(data?.userroles);
      })
      .catch((err) => {
        setFormErrors(err.message);
      });
  }, [org?.organization_id]);

  useEffect(() => {
    if (!Roles?.length || !userDetails.application_user_role_id) {
      return;
    }

    const match = Roles.find(
      (role) =>
        String(role.application_user_role_id) ===
        String(userDetails.application_user_role_id)
    );

    if (match) {
      setUserDetails((prev) => ({
        ...prev,
        organization_user_role_id: String(match.organization_user_role_id),
      }));
      return;
    }

    setUserDetails((prev) => ({
      ...prev,
      organization_user_role_id: "",
      application_user_role_id: "",
    }));
  }, [Roles, userDetails.application_user_role_id]);

  console.log("system roles", Roles);

  useEffect(() => {
    fetchGeneralCountries()
      .then((data) => {
        const formatted = data.countries.map((item) => ({
          name: item.country_name,
          code: item.country_code,
          phone_code: item.country_phone_code,
        }));
        setCountries(formatted);
        setCountryCode(formatted.find((item) => item.code === "IN"));
      })
      .catch((err) => setFormErrors(err.message));
  }, []);

  useEffect(() => {
    fetchUserTypes(org?.organization_id)
      .then((data) => {
        setUserTypes(data?.userTypes?.data);
      })
      .catch((err) => {
        setFormErrors(err.message);
      });
  }, []);

  // get user by id
  useEffect(() => {
    let getdataById = async () => {
      const response = await axios.get(
        `${MAIN_URL}/api/organizations/${org.organization_id}/user/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      console.log("reponse sos id is ", response);
      const a = response.data.user;
      const currentAppRole =
        a?.role_assignment?.application_user_role?.application_user_role_id;

      setOtherApplicationRoles(a?.other_application_roles || []);
      setUserDetails({
        email: a?.applicationuser?.[0]?.email,
        phone_number: a?.applicationuser?.[0]?.phone_number,
        full_name: a?.applicationuser?.[0]?.full_name,
        organization_user_type_id: a?.organization_user_type_id,
        phone_code: a?.applicationuser[0]?.country_phone_code,
        organization_user_role_id: "",
        application_user_role_id: currentAppRole ? String(currentAppRole) : "",
      });
      setLoading(false);
    };
    if (id) {
      setLoading(true);
      getdataById();
    }
  }, [id]);

  console.log("formdata", userDetails);

  const handleDetailChange = (e) => {
    const { name, value } = e.target;

    if (name === "organization_user_role_id") {
      const selectedRole = Roles.find(
        (role) => String(role.organization_user_role_id) === String(value)
      );
      setUserDetails((prev) => ({
        ...prev,
        organization_user_role_id: value,
        application_user_role_id:
          selectedRole?.application_user_role_id ?? prev.application_user_role_id,
      }));
      setFormErrors((prev) => ({ ...prev, organization_user_role_id: "" }));
      return;
    }

    setUserDetails((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  useEffect(() => {
    if (countryCode?.phone_code) {
      setUserDetails((prev) => ({
        ...prev,
        phone_code: countryCode.phone_code,
      }));
    }
  }, [countryCode]);

  const isValidEmail = (email) => {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email.trim());
  };

  const validateForm = () => {
    const errors = {};

    // if (!userDetails.email) errors.email = "User's email is required.";

    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // if (!emailRegex.test(userDetails.email)) {
    //   errors.email = "Please enter a valid email address.";
    // }

    if (userDetails.email && !isValidEmail(userDetails.email)) {
      errors.email = "Enter a valid  email address.";
    }

    if (!userDetails.email) errors.email = "Email is required.";

    if (!userDetails.full_name) errors.full_name = "User's Name is required.";

    if (!userDetails.phone_number) errors.phone_number = "Phone is required.";

    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleFinalSubmit = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);

    try {
      // Prepare payload with only allowed fields for update
      const payload = {
        full_name: userDetails.full_name,
        email: userDetails.email,
        phone_number: userDetails.phone_number,
        phone_code: userDetails.phone_code,
        organization_user_type_id: userDetails.organization_user_type_id,
        email:userDetails?.email,
        organization_user_role_id: userDetails?.organization_user_role_id
          ? Number(userDetails.organization_user_role_id)
          : null,
        application_user_role_id: userDetails?.application_user_role_id
          ? Number(userDetails.application_user_role_id)
          : null,
      };

      await axios.put(
        `${MAIN_URL}/api/organizations/${org.organization_id}/user/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success("User Updated!");
      setFormErrors({});
      navigate(-1);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 422) {
        const validationErrors =
          err.response.data.message || err.response.data.errors || {};
        setFormErrors(validationErrors);
        const errorMessages = Object.values(validationErrors).flat().join(" ");
        toast.error(errorMessages || "Validation failed.");
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <Box px={4} py={4} minHeight={"100vh"}>
      <Header
        mode={mode}
        updateMessage={"Edit User"}
        addMessage={"Add User"}
        homeLink={"/users"}
        homeText={"Users"}
      />

      <Paper elevation={3} sx={{ p: 3 }}>
        {otherApplicationRoles.length > 0 && (
          <Alert severity="info" sx={{ mb: 2 }}>
            This user has role(s) in other applications:{" "}
            {otherApplicationRoles.map((role) => role.user_role_name).join(", ")}.
            Select a role below to assign access for this application.
          </Alert>
        )}
        <Grid container spacing={2}>
          <TextField
            value={userDetails.full_name}
            error={!!formErrors.full_name}
            helperText={formErrors.full_name}
            fullWidth
            label="Full Name"
            name="full_name"
            onChange={handleDetailChange}
            disabled={isViewMode}
            required
          />

          <TextField
            value={userDetails.email}
            error={!!formErrors.email}
            helperText={formErrors.email}
            fullWidth
            label="Email"
            name="email"
            type="text"
            onChange={handleDetailChange}
            disabled={isViewMode}
            required
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              width: "100%",
            }}
          >
            <div
              style={{
                width: "25%",
              }}
            >
              <div
                style={{
                  border: "2px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "6px",
                  // padding: "1px 8px",
                }}
              >
                <SelectWithImage
                  value={countryCode}
                  error={false}
                  options={countries}
                  optionkey={"phone_code"}
                  onChange={(e, val) => setCountryCode(val)}
                  width="100%"
                  minWidth="20px"
                  disabled={isViewMode}
                  searchKeys={["name", "phone_code"]}
                />
              </div>
            </div>

            <TextField
              fullWidth
              label="Phone Number"
              name="phone_number"
              value={userDetails.phone_number}
              error={!!formErrors.phone_number}
              helperText={formErrors.phone_number}
              onChange={(e) => {
                const onlyDigits = e.target.value.replace(/\D/g, ""); // Remove non-digits
                if (onlyDigits?.length <= 20) {
                  handleDetailChange({
                    target: { name: "phone_number", value: onlyDigits },
                  });
                }
              }}
              disabled={isViewMode}
              required
              inputProps={{
                maxLength: 20,
                inputMode: "numeric",
                pattern: "[0-9]*",
              }}
            />
          </div>

          <TextField
            select
            fullWidth
            label="User Role"
            name="organization_user_role_id"
            value={userDetails.organization_user_role_id ?? ""}
            onChange={handleDetailChange}
            error={!!formErrors.organization_user_role_id}
            helperText={formErrors.organization_user_role_id}
            disabled={isViewMode || !Roles?.length}
          >
            {Roles?.map((option) => (
              <MenuItem
                key={option.organization_user_role_id}
                value={String(option.organization_user_role_id)}
              >
                {option.user_role_name || option.role_name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            fullWidth
            label="User Type"
            name="organization_user_type_id"
            value={userDetails.organization_user_type_id}
            onChange={handleDetailChange}
            error={!!formErrors.organization_user_type_id}
            helperText={formErrors.organization_user_type_id}
            disabled={isViewMode}
            required
          >
            {userTypes?.map((option) => (
              <MenuItem
                key={option?.organization_user_type_id}
                value={option?.organization_user_type_id}
              >
                {option?.user_type_name}
              </MenuItem>
            ))}
          </TextField>
          {/* 
          <Button
            variant="contained"
            onClick={handleFinalSubmit}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <CircularProgress size={22} sx={{ color: "#fff" }} />
            ) : (
              "Update User"
            )}
          </Button> */}

          {!isViewMode && (
            <Grid item>
              <Button
                variant="contained"
                onClick={handleFinalSubmit}
                disabled={btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2,
                  backgroundColor: "#1976d2",
                  "&:hover": { backgroundColor: "#115293" },
                }}
              >
                {btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : (
                  "Update User"
                )}
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button
              variant="contained"
              onClick={() => navigate(-1)}
              sx={{
                borderRadius: 2,
                minWidth: 120,
                textTransform: "capitalize",
                fontWeight: 500,
                mt: 2,
                backgroundColor: "#1976d2",
                "&:hover": { backgroundColor: "#115293" },
              }}
            >
              {isViewMode ? "Back" : "Cancel"}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}

export default UsersEdit;
